export { default } from "./ServicesCounterChips-component";
